// get all users
export const getAllTransactions = (filters) => ({
    url: "/admin/transactions",
    method: "GET",
    params: filters,
});
export const getSingleTransaction = (id) => ({
    url: `/admin/transactions/${id}`,
    method: "GET",
});
